
import { StepConditional } from '../PageParser/StepConditional';

/**
 * Hold a collection of Conditions and then have actions associated with them.
 */
export class ConditionEngine
{

    conditions : StepConditional[] = [];

    resetConditions()
    {
        this.conditions = [];
    }

    addCondition(step : StepConditional)
    {
        this.conditions.push(step);
    }

}